<template>
  <div
    v-loading="loading"
    class="user-profile-container"
    :class="{'mt-custom-75': !isMobile}"
  >
    <div
      v-if="isMobile"
      class="back-menu mobile-position-fixed"
    >
      <mobile-back-menu :title="$t('user-profile.title')" />
    </div>
    <div class="scroll-wrapper">
      <div class="user-profile-wrapper">
        <el-row class="user">
          <el-col :sm="14">
            <user-profile-card :user="item" />
          </el-col>
          <el-col
            class="map"
            :sm="10"
          >
            <GmapMap
              v-if="item.contact_info"
              class="google-map"
              :center="{ lat: Number(item.contact_info.latitude), lng: Number(item.contact_info.longitude) }"
              :zoom="maps.zoom"
              :options="maps.options"
              map-type-id="terrain"
            />
            <div
              class="custom-location-wrapper"
              style="width: auto"
            >
              <div class="user-location">
                <i
                  v-if="!isMobile && item.contact_info"
                  class="icon-place"
                >{{ item.contact_info.city }}</i>
              </div>
            </div>
          </el-col>
        </el-row>
        <h3 class="items-title">
          {{ $t('user-profile.ads.title') }}
        </h3>
        <el-row v-if="item.id">
          <el-col class="ads1-container">
            <entity-list
              ref="entityList"
              res="ads"
              :filter="adsFilter"
              :sort="getRequestSorts || []"
              :res-options="adsResourceOptions"
              :post-on-index="false"
            >
              <template
                slot="list"
                slot-scope="slotProps"
              >
                <template v-if="!isMobile">
                  <sort-ads />
                  <ads
                    :grid-col="gridCol"
                    :items="slotProps.list"
                    :ad-view-type="adViewType"
                    :user="true"
                  />
                </template>
                <template v-else>
                  <el-col
                    v-for="(item, index) in slotProps.list"
                    :key="`m-ad-${item.id}`"
                    class="col-item"
                    :span="12"
                  >
                    <ads-item
                      :item="item"
                      :index="index"
                      :is-ad="true"
                    />
                  </el-col>
                </template>
              </template>
            </entity-list>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-col v-if="isMobile">
      <footer-menu />
    </el-col>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import UserProfileCard from '@/components/UserProfileCard';
import SortAds from '@/components/Ads/SortAds';
import Ads from '@/components/Ads/Ads';
import AdsItem from '@/components/Ads/AdsItem';
import MobileBackMenu from '@/components/Mobile/MobileBackMenu';
import FooterMenu from '@/components/Mobile/FooterMenu';
import ResourcePage from '@/components/Core/ResourcePage';
import EntityList from '@/components/Core/EntityList';

export default {
  components: {
    FooterMenu,
    MobileBackMenu,
    AdsItem,
    Ads,
    SortAds,
    UserProfileCard,
    EntityList,
  },
  extends: ResourcePage,

  data() {
    return {
      resource: 'users',
      autoload: true,
      resourceOptions: {
        file: true,
        contact_info: true,
        favoring_logged_in_user: true,
      },
      adsResourceOptions: {
        file: true,
        currency: true,
        favoring_logged_in_user: true,
        contact_info: true,
        'category:parent': true,
      },
      gridCol: 8,
      maps: {
        zoom: 14,
        options: {
          fullscreenControl: false,
          mapTypeControl: false,
          panControl: false,
          rotateControl: false,
          streetViewControl: false,
          zoomControl: false,
        },
      },
    };
  },

  computed: {
    items() {
      return this.$store.state.ads.records;
    },
    adsFilter() {
      return [{
        property: 'active',
        operator: '=',
        value: true,
      }, {
        property: 'user_id',
        operator: '=',
        value: this.item.id,
      }];
    },
    ...mapState({
      isMobile: state => state.isMobile,
      adViewType: state => state.ad_view_type,
    }),
    ...mapGetters([
      'getRequestSorts',
    ]),
  },

  watch: {
    // On sort change do a refresh
    getRequestSorts() {
      setTimeout(() => this.$refs.entityList.doRefresh());
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/UserProfile.vue